// extracted by mini-css-extract-plugin
export default {"backToHelperDrawerBtn":"TextVisualizer_backToHelperDrawerBtn__QeLUr","sectionTitle":"TextVisualizer_sectionTitle__nO3P8"};